import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export interface Section {
  id: number
  name: string
}

export interface SectionsResponse {
  count: number
  next: string | null
  previous: string | null
  results: Section[]
}

export const useSectionsStore = defineStore('sections', () => {
  const sections = ref<Section[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchSections = async () => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get<SectionsResponse>(API_ROUTES.GET_SECTIONS)
      sections.value = response.data.results
      return response.data.results
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch sections'
      console.error('Error fetching sections:', err)
      return []
    } finally {
      isLoading.value = false
    }
  }

  return {
    sections,
    isLoading,
    error,
    fetchSections
  }
}) 